export default "__VITE_ASSET__Bac6y8b6__"